/**
 * Starting rungs for the bonus-ladder COMPOSER (Team Room → Milestones &
 * bonuses). These are editor defaults an admin overwrites before saving —
 * they are never rendered as data on a dashboard card.
 *
 * The old demo bonus-progress snapshot (fake roster, fake totals) is gone:
 * FETCH_BONUS_PROGRESS is server-only, and unconfigured workspaces show the
 * cards' own empty/setup states.
 */
export const DEMO_MILESTONES = [
  { target: 100000, bonus: 250 },
  { target: 250000, bonus: 500 },
  { target: 500000, bonus: 1000 },
  { target: 1000000, bonus: 2000 },
];
